/** @type {import('../schema').ExperienceEntity[]} */
export const sxswLondonEntities = [
  {
    id: 'sxsw-london',
    slug: 'sxsw-london',
    entityType: 'venue',
    name: 'SXSW London',
    shortDescription: 'A city-wide festival of technology, film, music, business, and culture centered in Shoreditch.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.sxswlondon.com/',
  },
  {
    id: 'truman-brewery',
    slug: 'truman-brewery',
    entityType: 'venue',
    name: 'The Truman Brewery',
    shortDescription: 'The former brewery complex that became a major SXSW London campus for sessions, stages, lounges, and festival activity.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'nobu-shoreditch',
    slug: 'nobu-london-shoreditch',
    entityType: 'hotel',
    name: 'Nobu Hotel London Shoreditch',
    shortDescription: 'A calm home base within walking distance of the conference venues.',
    city: 'London',
    country: 'United Kingdom',
    address: '10-50 Willow Street, London EC2A 4BH, United Kingdom',
    websiteUrl: 'https://london-shoreditch.nobuhotels.com/',
  },
  {
    id: 'artotel-london-hoxton',
    slug: 'artotel-london-hoxton',
    entityType: 'hotel',
    name: 'art’otel London Hoxton',
    shortDescription: 'Marcus’s London home base during SXSW London 2025, close to the Shoreditch conference footprint.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'demis-hassabis-ai',
    slug: 'demis-hassabis-ai',
    entityType: 'session',
    name: 'The Future of Artificial Intelligence',
    shortDescription: 'An opening conversation with Demis Hassabis that set the tone for the week.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'shoreditch-studios',
    slug: 'shoreditch-studios',
    entityType: 'venue',
    name: 'Shoreditch Studios',
    shortDescription: 'The SXSW London registration location where we collected our badges.',
    city: 'London',
    country: 'United Kingdom',
    address: "37 Bateman's Row, London EC2A 3HH, United Kingdom",
  },
  {
    id: 'the-view-from-2050',
    slug: 'the-view-from-2050',
    entityType: 'session',
    name: 'The View from 2050',
    shortDescription: 'Experts in AI, quantum technology, and entrepreneurship looked ahead to what the world could become and how we might get there.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'idris-elba-creativity-session',
    slug: 'idris-elba-creativity-as-capital-for-change',
    entityType: 'session',
    name: 'Creativity as Capital for Change',
    shortDescription: 'The Idris Elba session that drew a queue stretching for multiple blocks through Shoreditch.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'rethinking-robotics',
    slug: 'rethinking-robotics',
    entityType: 'session',
    name: 'Rethinking Robotics',
    shortDescription: 'A session at Shoreditch Electric that we attended briefly before leaving to regroup at The Reliance.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'building-ai-products',
    slug: 'building-ai-products',
    entityType: 'session',
    name: 'Building AI Products',
    shortDescription: 'A session at Shoreditch Electric that we tried to attend but missed because of the entry queue.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'ai-voice-revolution',
    slug: 'ai-voice-revolution',
    entityType: 'session',
    name: 'The AI Voice Revolution',
    shortDescription: 'A Wednesday session at the Truman Brewery attended during SXSW London.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'ai-agents-marketer',
    slug: 'ai-agents-marketers-new-best-friend',
    entityType: 'session',
    name: 'AI Agents: The Marketer’s New Best Friend?',
    shortDescription: 'A Wednesday afternoon session attended after a stop at The Golden Heart.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'agentic-ai-people-powered-future',
    slug: 'agentic-ai-people-powered-future',
    entityType: 'session',
    name: 'Agentic AI & The People Powered Future',
    shortDescription: 'A Thursday session attended before the second visit to The Reliance.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'village-underground',
    slug: 'village-underground',
    entityType: 'venue',
    name: 'Village Underground',
    shortDescription: 'A Shoreditch music venue where Henry Lau brought an international crowd together.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://villageunderground.co.uk/',
  },
  {
    id: 'curzon-hoxton',
    slug: 'curzon-hoxton',
    entityType: 'venue',
    name: 'Curzon Hoxton',
    shortDescription: 'An intimate cinema that hosted the Late Shift premiere and filmmaker Q&A.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.curzon.com/venues/hoxton/',
  },
  {
    id: 'barbican-centre',
    slug: 'barbican-centre',
    entityType: 'venue',
    name: 'Barbican Centre',
    shortDescription: 'The landmark arts center that hosted the Deep Cover premiere.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.barbican.org.uk/',
  },
  {
    id: 'the-ks-hoxton-hall',
    slug: 'the-ks-hoxton-hall',
    entityType: 'venue',
    name: 'The K’s at Hoxton Hall',
    shortDescription: 'A live set at Hoxton Hall between the Deep Cover premiere and the late night at XOYO.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'xoyo',
    slug: 'xoyo',
    entityType: 'venue',
    name: 'XOYO',
    shortDescription: 'A late-night club where Idris Elba closed out an unforgettable conference day.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://xoyo.co.uk/',
  },
  {
    id: 'old-street-records',
    slug: 'old-street-records',
    entityType: 'venue',
    name: 'Old Street Records',
    shortDescription: 'A record-store-inspired bar and live music venue near the center of the action.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.oldstreetrecords.com/',
  },
  {
    id: 'high-grade-coffee',
    slug: 'high-grade-coffee',
    entityType: 'restaurant',
    name: 'High Grade Coffee',
    shortDescription: 'The morning coffee stop that became part of the daily conference rhythm.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.highgrade.coffee/',
  },
  {
    id: 'owl-and-pussycat',
    slug: 'owl-and-pussycat',
    entityType: 'restaurant',
    name: 'Owl & Pussycat',
    shortDescription: 'A Shoreditch pub stop after the SXSW London opening party.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.owlandpussycatshoreditch.com/',
  },
  {
    id: 'shoreditch-fish-chips',
    slug: 'shoreditch-fish-and-chips',
    entityType: 'restaurant',
    name: 'Shoreditch Fish & Chips',
    shortDescription: 'A quick London classic between conference venues.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.shoreditchfishnchips.co.uk/',
  },
  {
    id: 'beigel-bake',
    slug: 'beigel-bake',
    entityType: 'restaurant',
    name: 'Beigel Bake',
    shortDescription: 'A famous Brick Lane stop for a fast, memorable late bite.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.beigelbake.co.uk/',
  },
  {
    id: 'queens-head',
    slug: 'queens-head',
    entityType: 'restaurant',
    name: "The Queen's Head",
    shortDescription: 'A historic pub stop woven naturally into the walk between venues.',
    city: 'London',
    country: 'United Kingdom',
    address: '221-222 Shoreditch High Street, London E1 6PJ, United Kingdom',
    websiteUrl: 'https://queensheadshoreditch.com/',
  },
  {
    id: 'george-and-vulture',
    slug: 'george-and-vulture',
    entityType: 'restaurant',
    name: 'George & Vulture',
    shortDescription: 'A centuries-old pub that gave the conference trip a sense of London history.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://georgeandvulture.com/',
  },
  {
    id: 'the-reliance',
    slug: 'the-reliance',
    entityType: 'restaurant',
    name: 'The Reliance',
    shortDescription: 'A relaxed pub for comparing notes between sessions.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://therelianceshoreditch.co.uk/',
  },
  {
    id: 'barley-mow',
    slug: 'barley-mow-shoreditch',
    entityType: 'restaurant',
    name: 'Barley Mow',
    shortDescription: 'A neighborhood pub stop during the Tuesday route through Shoreditch.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://thebarleymowshoreditch.co.uk/',
  },
  {
    id: 'bricklayers-arms',
    slug: 'bricklayers-arms-shoreditch',
    entityType: 'restaurant',
    name: 'Bricklayers Arms',
    shortDescription: 'A neighborhood pub stop during the Tuesday route through Shoreditch.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'old-blue-last',
    slug: 'old-blue-last',
    entityType: 'restaurant',
    name: 'The Old Blue Last',
    shortDescription: 'A storied Shoreditch pub and music landmark.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.theoldbluelast.com/',
  },
  {
    id: 'golden-heart',
    slug: 'golden-heart-spitalfields',
    entityType: 'restaurant',
    name: 'The Golden Heart',
    shortDescription: 'A Wednesday pub stop between two SXSW London sessions.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'tower-bridge-walk',
    slug: 'tower-bridge-bermondsey-walk',
    entityType: 'activity',
    name: 'Tower Bridge to Bermondsey Beer Mile',
    shortDescription: 'A long city walk from the Tower of London, across Tower Bridge, and into Bermondsey.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'doodle-bar',
    slug: 'doodle-bar-bermondsey',
    entityType: 'restaurant',
    name: 'Doodle Bar',
    shortDescription: 'The first brewery stop on the walk along the Bermondsey Beer Mile.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.thedoodlebar.com/',
  },
  {
    id: 'barrel-project',
    slug: 'barrel-project',
    entityType: 'restaurant',
    name: 'The Barrel Project',
    shortDescription: 'A brewery stop on the Bermondsey Beer Mile.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.thebarrelproject.co.uk/',
  },
  {
    id: 'hiver-taproom',
    slug: 'hiver-taproom',
    entityType: 'restaurant',
    name: 'Hiver Taproom',
    shortDescription: 'A honey-beer taproom stop on the Bermondsey Beer Mile.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://hiverbeers.com/pages/taproom',
  },
  {
    id: 'fabal-beerhall',
    slug: 'fabal-beerhall',
    entityType: 'restaurant',
    name: 'Fabal Beerhall',
    shortDescription: 'A colorful beer hall stop near the end of the Bermondsey Beer Mile.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://hiverbeers.com/pages/fabal-beerhall',
  },
  {
    id: 'poulet-london',
    slug: 'poulet-london',
    entityType: 'restaurant',
    name: 'Poulet',
    shortDescription: 'A neighborhood restaurant that saved the night with one last chicken.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.poulet.biz/',
  },
  {
    id: 'the-culpeper',
    slug: 'the-culpeper',
    entityType: 'restaurant',
    name: 'The Culpeper',
    shortDescription: 'A pub and rooftop stop on the final walk back toward Shoreditch.',
    city: 'London',
    country: 'United Kingdom',
    websiteUrl: 'https://www.theculpeper.com/',
  },
  {
    id: 'hunger-cure',
    slug: 'hunger-cure',
    entityType: 'restaurant',
    name: 'Hunger Cure',
    shortDescription: 'A final casual food stop that matched the spontaneous rhythm of the trip.',
    city: 'London',
    country: 'United Kingdom',
  },
  {
    id: 'dublin-side-quest',
    slug: 'dublin-side-quest',
    entityType: 'place',
    name: 'Dublin Side Quest',
    shortDescription: 'A quick Friday morning flight added one more city and one more country to the adventure.',
    city: 'Dublin',
    country: 'Ireland',
  },
  {
    id: 'hyatt-centric-dublin',
    slug: 'hyatt-centric-the-liberties-dublin',
    entityType: 'hotel',
    name: 'Hyatt Centric The Liberties Dublin',
    shortDescription: 'The Dublin home base for the bonus Friday side quest.',
    city: 'Dublin',
    country: 'Ireland',
    address: 'Dean Street, The Liberties, Dublin D08 W3X7, Ireland',
  },
  {
    id: 'brazen-head-dublin',
    slug: 'brazen-head-dublin',
    entityType: 'restaurant',
    name: 'The Brazen Head',
    shortDescription: 'The first Dublin stop, reached immediately after dropping the bags at the hotel.',
    city: 'Dublin',
    country: 'Ireland',
    websiteUrl: 'https://brazenhead.com/',
  },
  {
    id: 'bad-bobs-temple-bar',
    slug: 'bad-bobs-temple-bar',
    entityType: 'restaurant',
    name: 'Bad Bobs Temple Bar',
    shortDescription: 'The first Temple Bar-area stop for traditional Irish food and live music.',
    city: 'Dublin',
    country: 'Ireland',
    address: '35-37 Essex Street East, Temple Bar, Dublin 2, D02 Y891, Ireland',
    websiteUrl: 'https://badbobs.ie/',
  },
  {
    id: 'multi-pizza-dublin',
    slug: 'multi-pizza-dublin',
    entityType: 'restaurant',
    name: 'Multi Pizza',
    shortDescription: 'The late-night pizza stop near the Dublin hotel after the walk back from Temple Bar.',
    city: 'Dublin',
    country: 'Ireland',
  },
  {
    id: 'guinness-storehouse-tour',
    slug: 'guinness-storehouse-tour',
    entityType: 'activity',
    name: 'Guinness Storehouse Tour',
    shortDescription: 'A tour through the story, craft, and culture behind Guinness in Dublin.',
    city: 'Dublin',
    country: 'Ireland',
  },
  {
    id: 'temple-bar-dublin',
    slug: 'temple-bar-dublin',
    entityType: 'restaurant',
    name: 'The Temple Bar Pub',
    shortDescription: 'The second Temple Bar-area pub stop, visited after Bad Bobs.',
    city: 'Dublin',
    country: 'Ireland',
    address: '47-48 Temple Bar, Dublin 2, Ireland',
    websiteUrl: 'https://thetemplebarpub.com/',
  },
  {
    id: 'mercantile-hotel-dublin',
    slug: 'mercantile-hotel-dublin',
    entityType: 'restaurant',
    name: 'The Mercantile Hotel',
    shortDescription: 'A hotel and bar stop on the walk back from the Temple Bar area.',
    city: 'Dublin',
    country: 'Ireland',
    address: '28 Dame Street, Dublin 2, D02 ND77, Ireland',
    websiteUrl: 'https://www.mercantilehotel.ie/',
  },
];

const coordinatesById = {
  'nobu-shoreditch': { latitude: 51.5250976, longitude: -0.0830772 },
  'truman-brewery': { latitude: 51.5205171, longitude: -0.0734993 },
  'shoreditch-studios': { latitude: 51.5251531, longitude: -0.0787032 },
  'the-view-from-2050': { latitude: 51.5205171, longitude: -0.0734993 },
  'building-ai-products': { latitude: 51.5278046, longitude: -0.0823851 },
  'rethinking-robotics': { latitude: 51.5278046, longitude: -0.0823851 },
  'ai-voice-revolution': { latitude: 51.5205171, longitude: -0.0734993 },
  'ai-agents-marketer': { latitude: 51.5205171, longitude: -0.0734993 },
  'idris-elba-creativity-session': { latitude: 51.5205171, longitude: -0.0734993 },
  'agentic-ai-people-powered-future': { latitude: 51.5205171, longitude: -0.0734993 },
  'village-underground': { latitude: 51.5235955, longitude: -0.0786639 },
  'curzon-hoxton': { latitude: 51.5288806, longitude: -0.0837970 },
  'barbican-centre': { latitude: 51.5200363, longitude: -0.0921246 },
  'the-ks-hoxton-hall': { latitude: 51.5318655, longitude: -0.0797677 },
  xoyo: { latitude: 51.5254832, longitude: -0.0858335 },
  'old-street-records': { latitude: 51.5267804, longitude: -0.0807326 },
  'high-grade-coffee': { latitude: 51.5205171, longitude: -0.0734993 },
  'owl-and-pussycat': { latitude: 51.5242883, longitude: -0.0754746 },
  'shoreditch-fish-chips': { latitude: 51.5248869, longitude: -0.0720196 },
  'beigel-bake': { latitude: 51.5245116, longitude: -0.0717527 },
  'queens-head': { latitude: 51.5227650, longitude: -0.0782796 },
  'george-and-vulture': { latitude: 51.5291677, longitude: -0.0837874 },
  'the-reliance': { latitude: 51.5266210, longitude: -0.0814246 },
  'old-blue-last': { latitude: 51.5243657, longitude: -0.0800599 },
  'golden-heart': { latitude: 51.5201514, longitude: -0.0742199 },
  'tower-bridge-walk': { latitude: 51.5055158, longitude: -0.0753665 },
  'doodle-bar': { latitude: 51.5002049, longitude: -0.0764518 },
  'barrel-project': { latitude: 51.4994717, longitude: -0.0748793 },
  'fabal-beerhall': { latitude: 51.4993771, longitude: -0.0747406 },
  'hiver-taproom': { latitude: 51.4988354, longitude: -0.0746673 },
  'poulet-london': { latitude: 51.4997319, longitude: -0.0763761 },
  'the-culpeper': { latitude: 51.5168631, longitude: -0.0729435 },
  'hunger-cure': { latitude: 51.5256779, longitude: -0.0843439 },
  'dublin-side-quest': { latitude: 53.3388195, longitude: -6.2740935 },
  'hyatt-centric-dublin': { latitude: 53.3388195, longitude: -6.2740935 },
  'brazen-head-dublin': { latitude: 53.3449368, longitude: -6.2763108 },
  'guinness-storehouse-tour': { latitude: 53.3419328, longitude: -6.2867297 },
  'bad-bobs-temple-bar': { latitude: 53.3450328, longitude: -6.2659898 },
  'temple-bar-dublin': { latitude: 53.3454789, longitude: -6.2640728 },
  'mercantile-hotel-dublin': { latitude: 53.3440643, longitude: -6.2638575 },
  'multi-pizza-dublin': { latitude: 53.3397360, longitude: -6.2790336 },
};

sxswLondonEntities.forEach((entity) => {
  Object.assign(entity, coordinatesById[entity.id] || {});
});

export const sxswLondonEntityById = sxswLondonEntities.reduce((entities, entity) => ({
  ...entities,
  [entity.id]: entity,
}), {});
